// src/services/blogsService.js
import apiClient from './apiClient.js'

export const blogsService = {
    getBlogs(params = {}) {
        return apiClient.get('/blogs', { params })
    },

    getBlogBySlug(slug) {
        return apiClient.get(`/blogs/${slug}`)
    },

    getBlogCategories() {
        return apiClient.get('/blogs/categories')
    },

    createBlog(data) {
        return apiClient.post('/blogs', data)
    },

    updateBlog(id, data) {
        return apiClient.put(`/blogs/${id}`, data)
    },

    deleteBlog(id) {
        return apiClient.delete(`/blogs/${id}`)
    },

    likeBlog(slug) {
        return apiClient.post(`/blogs/${slug}/like`)
    },
}